import async from 'components/Async';
import { access, role } from 'constants/index';

const EmailReportPage = async(() => import('./report/EmailReportPage'));
const PITReportPage = async(() => import('./report/PITReportPage'));
const FeedProcessorSettingsPage = async(() => import('./jobmanager/FeedProcessorSettingsPage'));
const CreateEditFeedProcessingRulePage = async(() => import('./jobmanager/FeedProcessorSettingsPage/subpage/CreateEditFeedProcessingRulePage'));
const RawDataExportPage = async(() => import('./report/RawDataExportPage'));
const CompanyLogosPage = async(() => import('./tool/CompanyLogosPage'));
const JobSearchEmulatorPage = async(() => import('./tool/JobSearchEmulatorPage'));
const DeChangeLogPage = async(() => import('./report/DeChangeLogPage'));
const PartnerChangeLogPage = async(() => import('./report/PartnerChangeLogPage'));
const PartnerChangeLogGroupedPage = async(() => import('./report/PartnerChangeLogGroupedPage'));
const FeedManagementPage = async(() => import('./jobmanager/FeedManagementPage'));
const AdvertiserLogosPage = async(() => import('./tool/AdvertiserLogosPage'));

const adminRouteList = [
   {
      path: '/admin/report/email',
      requiresDeSession: true,
      component: EmailReportPage,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/admin/report/syndicated-jobs/pit',
      component: PITReportPage,
      access: access.getAdminAccessByApp.synJobFeed,
   },
   {
      path: '/admin/report/syndicated-jobs/pit-raw-data',
      requiresDeSession: true,
      component: RawDataExportPage,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      // KEEP twin: partner-gated like its sibling PIT Report (the original stays
      // DE:admin-gated and dies with DE — de-shutdown-decisions §2 KEEP+FIX)
      path: '/admin/report/syndicated-jobs/pit-raw-data-keep',
      component: RawDataExportPage,
      access: access.getAdminAccessByApp.synJobFeed,
   },
   {
      path: '/employer/de-changelog',
      requiresDeSession: true,
      component: DeChangeLogPage,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/partner/partner-changelog',
      component: PartnerChangeLogPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/partner/partner-changelog-grouped',
      component: PartnerChangeLogGroupedPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/admin/job-manager/job-expire-override',
      component: FeedProcessorSettingsPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/admin/job-manager/job-expire-override/:subroute',
      component: CreateEditFeedProcessingRulePage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/admin/tool/company-logos',
      component: CompanyLogosPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/admin/tool/advertiser-logos',
      component: AdvertiserLogosPage,
      access: access.getAdminAccessByApp.sponsoredAds,
   },
   {
      path: '/admin/tool/search-emulator',
      requiresDeSession: true,
      component: JobSearchEmulatorPage,
      access: {
         type: access.type.role,
         value: {
            partner: [
               role.partner.admin,
               role.partner.jobFeedReportInternal,
            ],
         },
      },
   },
   {
      // KEEP twin (AOE-free) — de-shutdown-decisions §2 KEEP+FIX
      path: '/admin/tool/search-emulator-keep',
      component: JobSearchEmulatorPage,
      access: {
         type: access.type.role,
         value: {
            partner: [
               role.partner.admin,
               role.partner.jobFeedReportInternal,
            ],
         },
      },
   },
   {
      path: '/admin/job-manager/feed-management',
      requiresDeSession: true,
      component: FeedManagementPage,
      access: access.byRole.employer.onlyAdmin,
   },
];

export default adminRouteList;
